module.exports = "<div class=\"content\">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <p>\n        notifications works!\n      </p>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/notifications/notifications.component.html
// module id = ../../../../../src/app/dashboard/notifications/notifications.component.html
// module chunks = main